'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.uploadMediaToFacebookSerializer = uploadMediaToFacebookSerializer;
exports.VariationSerializer = VariationSerializer;
exports.postBlueprintSerializer = postBlueprintSerializer;
exports.putBlueprintSerializer = putBlueprintSerializer;
exports.updateLayerTemplatesTooltipSerializer = updateLayerTemplatesTooltipSerializer;
exports.postLayerTemplatesSerializer = postLayerTemplatesSerializer;
exports.postVariationSerializer = postVariationSerializer;
exports.postUserVariationSerializer = postUserVariationSerializer;
exports.postGenerateCSVSerializer = postGenerateCSVSerializer;

var _effects = require('redux-saga/effects');

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _constants = require('../../../constants');

var _generic = require('../../../helpers/generic');

var _picasso = require('../../../helpers/picasso');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(postBlueprintSerializer),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(putBlueprintSerializer),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(postVariationSerializer),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(postUserVariationSerializer),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(postGenerateCSVSerializer);

function uploadMediaToFacebookSerializer(payload) {
  var media = payload.media,
      account_id = payload.account_id;

  return media.map(function (m) {
    return {
      is_fb_account_id: true,
      account_id: account_id,
      path: (0, _generic.getImageFromState)(m),
      fileName: m.name
    };
  });
}

var baseBlueprintSerializer = /*#__PURE__*/_regenerator2.default.mark(function baseBlueprintSerializer(payload) {
  var session;
  return _regenerator2.default.wrap(function baseBlueprintSerializer$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context.sent;
          return _context.abrupt('return', {
            organizationId: session.currentAdvertiser,
            createdBy: session.user.id,
            name: payload.name,
            type: payload.type,
            previewUrl: payload.thumbnailImage ? (0, _generic.getImageFromState)(payload.thumbnailImage[0]) : '',
            guideUrl: payload.guideImage ? (0, _generic.getImageFromState)(payload.guideImage[0]) : '',
            aeFileUrl: payload.aeFile ? (0, _generic.getImageFromState)(payload.aeFile[0]) : '',
            description: payload.description
          });

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, baseBlueprintSerializer, this);
});

function VariationSerializer(item) {
  return (0, _values2.default)((0, _omit2.default)(item, ["key", "preview"]));
}

function postBlueprintSerializer(payload) {
  var result;
  return _regenerator2.default.wrap(function postBlueprintSerializer$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(baseBlueprintSerializer, payload);

        case 2:
          result = _context2.sent;
          return _context2.abrupt('return', result);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked, this);
}

function putBlueprintSerializer(payload) {
  var result;
  return _regenerator2.default.wrap(function putBlueprintSerializer$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.call)(baseBlueprintSerializer, payload);

        case 2:
          result = _context3.sent;
          return _context3.abrupt('return', (0, _assign2.default)(result, {
            id: payload.id
          }));

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked2, this);
}

function updateLayerTemplatesTooltipSerializer(currentLayers, updatedLayers) {
  return currentLayers.map(function (layer) {
    var updatedLayer = updatedLayers.find(function (newLayer) {
      return newLayer.id === layer.id;
    });
    return (0, _extends3.default)({}, layer, {
      tooltip: updatedLayer.tooltip || currentLayers.tooltip || '',
      enableUserMedia: updatedLayer.enableUserMedia
    });
  });
}

function postLayerTemplatesSerializer(payload) {
  var buildSupportedItemValidator = function buildSupportedItemValidator(values) {
    return {
      type: 'SUPPORTED_ITEM_VALIDATOR',
      args: values
    };
  };

  var buildCharacterCountValidator = function buildCharacterCountValidator(value) {
    return {
      type: 'CHARACTER_COUNT_VALIDATOR',
      args: value
    };
  };

  var buildValidators = function buildValidators(item) {
    var arrayOfValidators = [];
    switch (item.contentType) {
      case 'COLOR':
        if (!item.colours) {
          throw (0, _assign2.default)({
            title: "Error",
            message: 'Layer \'' + item.title + '\' requires at least one item'
          });
        }
        arrayOfValidators.push(buildSupportedItemValidator(item.colours.map(function (colour) {
          return colour.hex.replace('#', '');
        })));
        return arrayOfValidators;
      case 'VIDEO':
      case 'IMAGE':
      case 'AUDIO':
        {
          if (!item.enableUserMedia && !(item.media && item.media.length)) {
            throw (0, _assign2.default)({
              title: "Error",
              message: 'Layer \'' + item.title + '\' requires at least one item or \'Enable user Media\' selected'
            });
          }
          var media = item.media || [];
          arrayOfValidators.push(buildSupportedItemValidator(media.map(function (item) {
            return (0, _generic.getImageFromState)(item);
          })));
          return arrayOfValidators;
        }
      case 'TEXT':
        arrayOfValidators.push(buildCharacterCountValidator(['' + (item.characterCount || 1)]));
        return arrayOfValidators;
      default:
        return arrayOfValidators;
    }
  };

  return {
    layerTemplates: payload.map(function (item) {
      if (!item.contentType) {
        throw (0, _assign2.default)({
          title: "Error",
          message: '\'Layer ' + item.title + '\' requires a type'
        });
      }

      return {
        title: item.title,
        contentType: item.contentType,
        validators: buildValidators(item),
        tooltip: item.tooltip,
        enableUserMedia: item.enableUserMedia
      };
    })
  };
}

function postVariationSerializer(payload) {
  var blueprint, session, user, currentAdvertiser, updatedPayload, buildVariation;
  return _regenerator2.default.wrap(function postVariationSerializer$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(function (state) {
            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
          });

        case 2:
          blueprint = _context4.sent;
          _context4.next = 5;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 5:
          session = _context4.sent;
          user = session.user, currentAdvertiser = session.currentAdvertiser;
          updatedPayload = payload.map(function (item) {
            return (0, _assign2.default)({}, item);
          });

          buildVariation = function buildVariation() {
            return updatedPayload.map(function (item) {
              return VariationSerializer(item);
            });
          };

          return _context4.abrupt('return', {
            blueprintId: blueprint.id,
            layers: blueprint.layerTemplates.map(function (layer) {
              return layer.id;
            }),
            variations: buildVariation(),
            userName: user.first_name + ' ' + user.last_name,
            userEmail: user.email,
            organizationId: currentAdvertiser
          });

        case 10:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked3, this);
}

function postUserVariationSerializer(payload) {
  var blueprint, session, rowSerializer, payloadAsString;
  return _regenerator2.default.wrap(function postUserVariationSerializer$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(function (state) {
            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
          });

        case 2:
          blueprint = _context5.sent;
          _context5.next = 5;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 5:
          session = _context5.sent;

          rowSerializer = function rowSerializer(item) {
            var newItem = (0, _omit2.default)(item, ["key"]);
            var previewObj = newItem.preview || null;

            if (previewObj) {
              // Need to omit the case where there's a local loading state for generating a Preview from Picasso, but that request hasn't finished.
              // ie If the user reloads before there is a preview made on the backend, we can't recover it, so we'll have to omit `preview` from the row - JT
              if (previewObj.requestingPreview) {
                newItem = (0, _omit2.default)(newItem, ["preview"]);
              } else if (previewObj.flashCompleted) {
                // remove `flashCompleted` since it's purely aesthetic to show user preview is ready
                newItem.preview = (0, _picasso.unsetPreviewFlashCompleted)(previewObj);
              }
            }

            return newItem;
          };

          payloadAsString = (0, _generic.convertArrayToEscapedString)(payload, function (item) {
            return (0, _stringify2.default)(rowSerializer(item));
          });
          return _context5.abrupt('return', {
            organizationId: session.currentAdvertiser,
            blueprintId: blueprint.id,
            userId: session.user.id,
            value: payloadAsString
          });

        case 9:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked4, this);
}

/* TODO: refactor switch logic to share it with postLayerTemplatesSerializer */
function postGenerateCSVSerializer(_ref) {
  var layerTemplates = _ref.layerTemplates;
  var blueprint, arrays, header;
  return _regenerator2.default.wrap(function postGenerateCSVSerializer$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(function (state) {
            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
          });

        case 2:
          blueprint = _context6.sent;
          arrays = layerTemplates.map(function (layerTemplate) {
            switch (layerTemplate.contentType) {
              case 'COLOR':
                return layerTemplate.colours ? layerTemplate.colours.map(function (colour) {
                  return colour.hex;
                }) : [];
              case 'VIDEO':
              case 'IMAGE':
              case 'AUDIO':
                return layerTemplate.media ? layerTemplate.media.map(function (item) {
                  return item.url || (0, _generic.getImageFromState)(item);
                }) : [];
              case 'TEXT':
                return [(0, _generic.loremIpsumTextGenerator)(layerTemplate.characterCount)];
              default:
                return [''];
            }
          });

          // TEMP change, instead of creating all possible permutaions, the csv will just be one permutaion consisting of
          // the last (most recent) value of each layer.
          // Generating all permutations can get crazy and freezes/crashes chrome page - JT

          header = layerTemplates.map(function (layerTemplate) {
            return layerTemplate.title;
          });
          return _context6.abrupt('return', {
            blueprintId: blueprint.id,
            values: [header, arrays.map(function (arr) {
              return arr[arr.length - 1];
            })]
          });

        case 6:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked5, this);
}


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/store/blueprint/serializers/index.js
// module id = 3914
// module chunks = 5 6 7 8